<template>
  <alternative-login-component></alternative-login-component>
</template>

<script>
import AlternativeLoginComponent from "../../components/registration/alternativeLoginComponent";
export default {
  name: "AlternativeLogin",
  components: { AlternativeLoginComponent },
};
</script>

<style scoped></style>
